<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->




/* ==========================================================
   قائمة الجوال
   ----------------------------------------------------------
   جعل تبويب "التصنيفات" هو التبويب الافتراضي
   عند فتح القائمة الجانبية على الجوال.
   ========================================================== */


document.addEventListener('click', function (event) {
  const openButton = event.target.closest(
    '[data-menu-mobile], [data-mobile-menu-toggle], .mobileMenu-toggle'
  );

  if (!openButton) return;

  setTimeout(function () {
    const header = document.querySelector('.menu-heading-mobile');

    if (!header) return;

    const tabs = header.querySelectorAll('.title');

    if (tabs.length < 2) return;

    tabs[0].classList.remove('is-active');
    tabs[1].classList.add('is-active');

    tabs[1].click();
  }, 100);
});







/* ==========================================================
  زر الاقسام في تول بار الجوال يفتح القائمة الجانبية
   ----------------------------------------------------------
   ========================================================== */


document.addEventListener('click', function (e) {
    const btn = e.target.closest('.toolbar-categories-btn');
    if (!btn) return;

    e.preventDefault();

    document.querySelector('.mobileMenu-toggle')?.click();
});